"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconDistrictCooling = function IconDistrictCooling(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m24.14 22-5.082-8.795 2.38-5.943-1.856-.744-1.797 4.484-3.18-5.502-1.73 1 3.175 5.497-4.778-.687-.284 1.98 6.335.91 5.275 9.13H12.505l-4.219-5.368-1.572 1.236L9.96 23.33H3v2h6.443l-2.73 3.472 1.573 1.236 3.7-4.708h10.23l-4.893 8.47-6.335.91.284 1.98 4.778-.687-3.176 5.497 1.732 1 3.18-5.502 1.796 4.484 1.856-.744-2.38-5.943L24.14 26l5.08 8.8-2.388 5.937 1.856.746 1.802-4.481 3.174 5.498 1.732-1-3.173-5.497 4.775.687.284-1.98-6.331-.91-4.889-8.47h10.23l3.691 4.707 1.574-1.234-2.723-3.473H45v-2h-6.684l3.24-4.133-1.573-1.234-4.208 5.367H25.68l5.27-9.129 6.331-.911-.284-1.98-4.775.687L35.396 6.5l-1.732-1-3.174 5.498-1.802-4.481-1.856.746L29.22 13.2z",
    clipRule: "evenodd"
  })));
};

export { IconDistrictCooling, IconDistrictCooling as default };
